import React from 'react';
import { Avatar, Popover, Button, theme } from 'antd';

const { useToken } = theme;

export default function HeaderAccount({ user, signOut }) {
  const { token } = useToken();
  return (
    <div className="header__account">
      {!!user && (
        <>
          <Avatar src={user.photoURL} size={32} style={{ marginRight: token.marginXS }} />
          <Popover
            trigger="hover"
            placement="bottomLeft"
            content={
              <div
                style={{ padding: `${token.padding}px ${token.paddingLG}px`, minWidth: '260px' }}
              >
                <div style={{ marginBottom: token.margin }}>{user.email}</div>
                <Button type="primary" onClick={signOut}>
                  登出
                </Button>
              </div>
            }
          >
            <Button size="middle" style={{ verticalAlign: 'middle' }}>
              {user.displayName}
            </Button>
          </Popover>
        </>
      )}
    </div>
  );
}
